export const inlineEdit = {
  Grid_Edit_Cell: _TL_('Edit cell of column {{columnName}} and row {{rowIndex}}'),
  Grid_EditButtonText: _TL_('Edit'),
  Save: _TL_('Save'),
  Cancel: _TL_('Cancel'),
  Loading: _TL_('Loading...'),
  Schema_ReportEmailRule_Property_Cron: _TL_('Frequency'),
  Schema_ReportEmailRule_Property_StartTime: _TL_('Start date'),
  Schema_ReportEmailRule_Property_EndTime: _TL_('End date'),
  InlineDownloadReports_EmailAndScheduling_SendReportTo: _TL_('Send report to'),
  InlineDownloadReports_SearchUsers: _TL_('Search users'),
  InlineDownloadReports_EmailAndScheduling_Email_Me: _TL_('me'),
  InlineDownloadReports_EmailAndScheduling_Email_Template_Me: _TL_('{{email}} ({{me}})'),
  InlineDownloadReports_EmailAndScheduling_User: _TL_('{{email}} {{firstName}} {{lastName}}'),
  InlineDownloadReports_EmailAndScheduling_FailedToLoadUsers: _TL_('Failed to load users'),
  InlineDownloadReports_EmailAndScheduling_AllUsers: _TL_('All users with access to view reports'),
  'Click to learn more about {{item}}': _TL_('Click to learn more about {{item}}'),
  SimpleForm_Button_Save: _TL_('Save'),
  SimpleForm_Button_Cancel: _TL_('Cancel'),
  KoSchema_String_RemainingCharactersText: _TL_('{{count}} characters remaining'),
  KoSchema_String_ExceededCharactersText: _TL_('Exceeded by {{count}} characters'),
  /* Start: date range column */
  Custom: _TL_('Custom'),
  Schema_Enum_DateRangePreset_AllTime: _TL_('Entire time'),
  Schema_Enum_DateRangePreset_LastBusinessWeek: _TL_('Last business week'),
  Schema_Enum_DateRangePreset_LastFourteenDays: _TL_('Last 14 days'),
  Schema_Enum_DateRangePreset_LastMonth: _TL_('Last month'),
  Schema_Enum_DateRangePreset_LastSevenDays: _TL_('Last 7 days'),
  Schema_Enum_DateRangePreset_LastSixMonth: _TL_('Last six month'),
  Schema_Enum_DateRangePreset_LastThirtyDays: _TL_('Last 30 days'),
  Schema_Enum_DateRangePreset_LastThreeMonth: _TL_('Last three month'),
  Schema_Enum_DateRangePreset_LastWeekStartingMon: _TL_('Last week (Mon - Sun)'),
  Schema_Enum_DateRangePreset_LastWeekStartingSun: _TL_('Last week (Sun - Sat)'),
  Schema_Enum_DateRangePreset_LastYear: _TL_('Last year'),
  Schema_Enum_DateRangePreset_ThisMonth: _TL_('This month'),
  Schema_Enum_DateRangePreset_ThisWeekFromMon: _TL_('This week (Mon - Today)'),
  Schema_Enum_DateRangePreset_ThisWeekFromSun: _TL_('This week (Sun - Today)'),
  Schema_Enum_DateRangePreset_ThisYear: _TL_('This year'),
  Schema_Enum_DateRangePreset_Today: _TL_('Today'),
  Schema_Enum_DateRangePreset_Yesterday: _TL_('Yesterday'),
  /* End: date range column */
};
